import { EAssetType } from '../../../@types/FilesAPIModels';
import filesApiService from '../../../utils/filesApiService';
import { loadMaterialTexture } from '../../../utils/textureLoaderUtility';

/**
 * Async helper: Given minimal texture data (id, rotation, offset, assetType),
 * fetch full texture data from the API.
 */
export const fetchLegacyTextureFromApi = async (textureData: any): Promise<any> => {
  if (!textureData) return null;
  try {
    if (textureData.type === EAssetType.MATERIAL) {
      const tex = await loadMaterialTexture(textureData.id);
      return {
        id: textureData.id,
        name: textureData.name,
        material: tex,
        color: undefined,
        rotation: textureData.rotation,
        offset: textureData.offset,
        type: EAssetType.MATERIAL,
      };
    } else if (textureData.type === EAssetType.COLOR) {
      const colorData = await filesApiService.getColorById(textureData.id);
      return {
        id: textureData.id,
        name: textureData.name,
        material: null,
        color: colorData ? colorData.hex : undefined,
        rotation: textureData.rotation,
        offset: textureData.offset,
        type: EAssetType.COLOR,
      };
    }
    return null;
  } catch (error) {
    console.error('Error fetching texture with id', textureData.id, error);
    return null;
  }
};
